import React from 'react'

import { AppsIntegrationUnifiedView } from './AppsIntegrationUnifiedView'
import { useIntegration } from './hooks/useIntegration'
import type { AppsIntegrationUnifiedProps } from './types'

export const AppsIntegrationUnified = (props: AppsIntegrationUnifiedProps) => {
  const { connectBar, status } = useIntegration({
    name: props.name,
    logoSrc: props.logoSrc,
    description: props.connectDescription,
    id: props.appId,
    returnUrl: props.returnUrl,
    recoveryActions: props.recoveryActions,
  })

  const connected = status === 'CONNECTED'

  return (
    <AppsIntegrationUnifiedView
      connectBar={connectBar}
      name={props.name}
      longDescription={props.longDescription}
      helpCenterUrl={props.helpCenterUrl}
    >
      {connected ? props.children : <div />}
    </AppsIntegrationUnifiedView>
  )
}
